import { motion } from "framer-motion";
import { splitTitle } from "./Services";

function toEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{6,})/);
  return match ? `https://www.youtube-nocookie.com/embed/${match[1]}` : null;
}

export default function Videos({ content }) {
  const videos = (content?.youtube_videos || [])
    .map((v) => ({ ...v, embed: toEmbedUrl(v.url) }))
    .filter((v) => v.embed);

  if (videos.length === 0) return null;

  const eyebrow = content?.videos_eyebrow || "06 /// ON THE CHANNEL";
  const [titleA, titleB] = splitTitle(content?.videos_title || "Watch the Work");

  return (
    <section id="videos" className="border-y border-[#263342] bg-[#0D1117] py-24 sm:py-32" data-testid="videos-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-crimson font-semibold mb-4">{eyebrow}</p>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-slate-100">
            {titleA} <span className="text-outline">{titleB}</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-2 gap-4" data-testid="videos-grid">
          {videos.map((v, i) => (
            <motion.figure
              key={`${v.url}-${i}`}
              data-testid={`video-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="bg-panel border border-[#263342] overflow-hidden hover:border-crimson/50 transition-colors"
            >
              <div className="aspect-video">
                <iframe
                  src={v.embed}
                  title={v.title || `Werkhaus video ${i + 1}`}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
              {v.title && (
                <figcaption className="px-5 py-4 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400">
                  {v.title}
                </figcaption>
              )}
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
